import formAppSportRoomBlackouts from './formAppSportRoomBlackouts';
import tableAppBlackouts from './tableAppBlackouts';

export default {
  title: 'Blackout form',
  attributeName:'appBlackouts',
  createURL: 'appId/appBlackouts',
  sessionParams: [],
  getURL: 'appId/appBlackouts',
  updateURL: 'appId/appBlackouts',
  sessionParams: ['appId'],

  idAttribute: 'id',
  noArea: true,
  goBack: true,
  autoUpdate: true,
  formConfig: [
    formAppSportRoomBlackouts,
  ],

};
